export const ANIMATION_DURATION = 3000;
export const minOdd = 1.1;
